import { render, staticRenderFns } from "./AssigneeDashboard.vue?vue&type=template&id=c1e2b0e4&scoped=true&"
import script from "./AssigneeDashboard.vue?vue&type=script&lang=js&"
export * from "./AssigneeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AssigneeDashboard.vue?vue&type=style&index=0&id=c1e2b0e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e2b0e4",
  null
  
)

export default component.exports